// src/redux/actions.js

export const SET_CATEGORY = "SET_CATEGORY";
export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";

// Action Types for Hero User
export const SET_HERO_USER = "SET_HERO_USER";
export const CLEAR_HERO_USER = "CLEAR_HERO_USER";

// Action Creators
export const setCategory = (category) => ({
  type: SET_CATEGORY,
  payload: category,
});

export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
});

export const clearUser = () => ({
  type: CLEAR_USER,
});

// Action Creators for Hero User
export const setHeroUser = (heroUser) => ({
  type: SET_HERO_USER,
  payload: heroUser,
});

export const clearHeroUser = () => ({
  type: CLEAR_HERO_USER,
});

// Action Creators for Learning Content
export const setLearningContent = (contentData) => ({
  type: "SET_LEARNING_CONTENT",
  payload: contentData,
});

export const clearLearningContent = () => ({
  type: "CLEAR_LEARNING_CONTENT",
});

// *** New Action for Unit Code ***
export const SET_UNIT_CODE = "SET_UNIT_CODE";
export const setUnitCode = (unitCode) => ({
  type: SET_UNIT_CODE,
  payload: unitCode,
});

// --- Unit‑context slice ---------------------------------------------
export const SET_UNIT_CONTEXT = "SET_UNIT_CONTEXT";
export const CLEAR_UNIT_CONTEXT = "CLEAR_UNIT_CONTEXT";

/**
 * Overwrite the entire unit‑context slice.
 * @param {{
 *   programId: string,
 *   unitName:  string,
 *   unitCode:  string,
 *   company:   string,
 *   collectionBrand: string,
 *   learnerUid: string|null,
 *   userDisplayName: string,
 *   role: "learner"|"editor"
 * }} ctx
 */
export const setUnitContext = (ctx) => ({
  type: SET_UNIT_CONTEXT,
  payload: ctx,
});

export const clearUnitContext = () => ({
  type: CLEAR_UNIT_CONTEXT,
});
// src/redux/actions.js (or actionsFolder/…)
export const SET_LAST_WRITTEN_UID = "SET_LAST_WRITTEN_UID";

export const setLastWrittenUid = (uid) => ({
  type: SET_LAST_WRITTEN_UID,
  payload: uid,
});

// *** New Actions for Contractor Form Data ***
export const SET_CONTRACTOR_FORM_DATA = "SET_CONTRACTOR_FORM_DATA";
export const UPDATE_CONTRACTOR_FORM_DATA = "UPDATE_CONTRACTOR_FORM_DATA";
export const CLEAR_CONTRACTOR_FORM_DATA = "CLEAR_CONTRACTOR_FORM_DATA";

export const setContractorFormData = (formData) => ({
  type: SET_CONTRACTOR_FORM_DATA,
  payload: formData,
});

export const updateContractorFormData = (fieldName, value) => ({
  type: UPDATE_CONTRACTOR_FORM_DATA,
  payload: { fieldName, value },
});

export const clearContractorFormData = () => ({
  type: CLEAR_CONTRACTOR_FORM_DATA,
});

// *** New Actions for Supplier Form Data ***
export const SET_SUPPLIER_FORM_DATA = "SET_SUPPLIER_FORM_DATA";
export const UPDATE_SUPPLIER_FORM_DATA = "UPDATE_SUPPLIER_FORM_DATA";
export const CLEAR_SUPPLIER_FORM_DATA = "CLEAR_SUPPLIER_FORM_DATA";
export const SET_SUPPLIER_EXTRACTED_DATA = "SET_SUPPLIER_EXTRACTED_DATA";
export const SET_SUPPLIER_RESOLVED_FIELDS = "SET_SUPPLIER_RESOLVED_FIELDS";

export const setSupplierFormData = (formData) => ({
  type: SET_SUPPLIER_FORM_DATA,
  payload: formData,
});

export const updateSupplierFormData = (fieldName, value) => ({
  type: UPDATE_SUPPLIER_FORM_DATA,
  payload: { fieldName, value },
});

export const clearSupplierFormData = () => ({
  type: CLEAR_SUPPLIER_FORM_DATA,
});

export const setSupplierExtractedData = (extractedData) => ({
  type: SET_SUPPLIER_EXTRACTED_DATA,
  payload: extractedData,
});

export const setSupplierResolvedFields = (resolvedFields) => ({
  type: SET_SUPPLIER_RESOLVED_FIELDS,
  payload: resolvedFields,
});

// Additional actions for UI state management
export const SET_SUPPLIER_LOADING = "SET_SUPPLIER_LOADING";
export const SET_SUPPLIER_LOADING_LABEL = "SET_SUPPLIER_LOADING_LABEL";
export const SET_SUPPLIER_RESULT = "SET_SUPPLIER_RESULT";
export const SET_SUPPLIER_CURRENT_SECTION = "SET_SUPPLIER_CURRENT_SECTION";
export const SET_SUPPLIER_SHOW_OUTPUT = "SET_SUPPLIER_SHOW_OUTPUT";

export const setSupplierLoading = (loading) => ({
  type: SET_SUPPLIER_LOADING,
  payload: loading,
});

export const setSupplierLoadingLabel = (label) => ({
  type: SET_SUPPLIER_LOADING_LABEL,
  payload: label,
});

export const setSupplierResult = (result) => ({
  type: SET_SUPPLIER_RESULT,
  payload: result,
});

export const setSupplierCurrentSection = (index) => ({
  type: SET_SUPPLIER_CURRENT_SECTION,
  payload: index,
});

export const setSupplierShowOutput = (show) => ({
  type: SET_SUPPLIER_SHOW_OUTPUT,
  payload: show,
});

// *** New Actions for Record Management ***
export const SET_RECORD_EDITING_FIELD = "SET_RECORD_EDITING_FIELD";
export const SET_RECORD_EDITED_VALUE = "SET_RECORD_EDITED_VALUE";
export const CLEAR_RECORD_EDITING = "CLEAR_RECORD_EDITING";
export const SET_RECORD_UPDATE_RESULT = "SET_RECORD_UPDATE_RESULT";

export const setRecordEditingField = (field, isEditing) => ({
  type: SET_RECORD_EDITING_FIELD,
  payload: { field, isEditing },
});

export const setRecordEditedValue = (field, value) => ({
  type: SET_RECORD_EDITED_VALUE,
  payload: { field, value },
});

export const clearRecordEditing = () => ({
  type: CLEAR_RECORD_EDITING,
});

export const setRecordUpdateResult = (result) => ({
  type: SET_RECORD_UPDATE_RESULT,
  payload: result,
});

// --- Learner / Editor view ---------------------------------
export const SET_LEARNER_VIEW = "SET_LEARNER_VIEW";

/**
 * Marks the current view as learner or editor.
 * @param {boolean} isLearner  true  = learner view, false = editor
 * @param {string|null} learnerUid   UID when learner, null for editor
 */
export const setLearnerView = (isLearner, learnerUid = null) => ({
  type: SET_LEARNER_VIEW,
  payload: { isLearner, learnerUid },
});

// --- Editing toolbar toggle ---------------------------------
export const SET_IS_EDITING = "SET_IS_EDITING";

export const setIsEditing = (flag /* true | false */) => ({
  type: SET_IS_EDITING,
  payload: flag,
});

// *** Learner Data Actions ***
export const SET_LEARNER_DATA = "SET_LEARNER_DATA";
export const PATCH_LEARNER_DATA = "PATCH_LEARNER_DATA";
export const SET_LEARNER_LOADING = "SET_LEARNER_LOADING";
export const SET_LEARNER_ERROR = "SET_LEARNER_ERROR";
export const CLEAR_LEARNER_DATA = "CLEAR_LEARNER_DATA";

export const setLearnerData = (learnerData) => ({
  type: SET_LEARNER_DATA,
  payload: learnerData,
});

/** Shallow-merge fields into `learnerData` (e.g. cached UI snapshots). */
export const patchLearnerData = (partial) => ({
  type: PATCH_LEARNER_DATA,
  payload: partial || {},
});

export const setLearnerLoading = (loading) => ({
  type: SET_LEARNER_LOADING,
  payload: loading,
});

export const setLearnerError = (error) => ({
  type: SET_LEARNER_ERROR,
  payload: error,
});

export const clearLearnerData = () => ({
  type: CLEAR_LEARNER_DATA,
});

// ─────────────────────────────────────────────────────────────
// Baseline Assessment (programme-level)
// ─────────────────────────────────────────────────────────────
export const SET_BASELINE_ASSESSMENTS = "SET_BASELINE_ASSESSMENTS";
export const CLEAR_BASELINE_ASSESSMENTS = "CLEAR_BASELINE_ASSESSMENTS";
export const SET_BASELINE_LOADING = "SET_BASELINE_LOADING";
export const SET_BASELINE_ERROR = "SET_BASELINE_ERROR";
export const SET_BASELINE_CURRENT_PROGRAM = "SET_BASELINE_CURRENT_PROGRAM";

// ✅ NEW: Persist company/collectionBrand (+optional learnerId/programName) for the baseline page
export const SET_BASELINE_CONTEXT = "SET_BASELINE_CONTEXT";

/**
 * payload: { programName, written: {...}, verbal: {...} }
 */
export const setBaselineAssessments = (payload) => ({
  type: SET_BASELINE_ASSESSMENTS,
  payload,
});

/**
 * Clear a single programme or all.
 *  - pass { programName } to clear only that one
 *  - pass nothing to clear the entire slice
 */
export const clearBaselineAssessments = (programName = null) => ({
  type: CLEAR_BASELINE_ASSESSMENTS,
  payload: programName,
});

export const setBaselineLoading = (loading, label = "") => ({
  type: SET_BASELINE_LOADING,
  payload: { loading, label },
});

export const setBaselineError = (error = null) => ({
  type: SET_BASELINE_ERROR,
  payload: error,
});

/** Optional: remember which programme is active in the baseline UI */
export const setBaselineCurrentProgram = (programName) => ({
  type: SET_BASELINE_CURRENT_PROGRAM,
  payload: programName,
});

/** ✅ NEW: persist the context for BaselineAssessmentPage to read after nav */
export const setBaselineContext = ({
  company,
  collectionBrand,
  learnerId,
  programName,
} = {}) => ({
  type: SET_BASELINE_CONTEXT,
  payload: { company, collectionBrand, learnerId, programName },
});

// FleetCore tenant context (company + collection brand for all DB calls)
export const setFleetCoreContext = ({
  company,
  collectionBrand,
  companyName,
  registrationNumber,
  role,
} = {}) => ({
  type: "SET_FLEETCORE_CONTEXT",
  payload: {
    company,
    collectionBrand,
    companyName,
    registrationNumber,
    role,
  },
});

export const clearFleetCoreContext = () => ({
  type: "CLEAR_FLEETCORE_CONTEXT",
});
